import { helper, slugify } from '@heyform-inc/utils'

export function loadScript(src: string): void {
  const script = document.createElement('script')
  script.src = src
  document.head.appendChild(script)
}

export function loadStyle(src: string): void {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = src
  document.head.appendChild(link)
}

export function slugifyText(text: string): string {
  return helper.isValid(text)
    ? slugify(text.toLowerCase(), { replacement: '-' })
    : ''
}

export function randomArray<T>(array: T[], count: number): T[] {
  const indexes: number[] = Array.from({ length: array.length })
    .map((_, index) => index)
    .sort(() => (Math.random() > 0.5 ? 1 : -1))
    .slice(0, count)

  return indexes.map(index => {
    return array[index]
  })
}

export function getPageSize(total: number, limit: number, offset = 0): number {
  if (total < 1) {
    return 0
  } else if (total < limit + offset) {
    return 1
  } else {
    return Math.ceil((total - limit - offset) / limit) + 1
  }
}

export function merge<T extends Record<string | number | symbol, any>>(
  defaultObject: T,
  customObject: T
) {
  Object.keys(defaultObject).forEach((key: keyof T) => {
    const value = customObject[key]

    if (helper.isEmpty(value)) {
      customObject[key] = defaultObject[key]
    }
  })
}

export function unique<T>(array: T[]): T[] {
  return Array.from(new Set(array))
}
